module.exports = __webpack_public_path__ + "img/29.6fc740d0.jpg";